import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({
  children,
  adminOnly = false,
  platformOnly = false,
}: {
  children: JSX.Element;
  adminOnly?: boolean;
  platformOnly?: boolean;
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading-block">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (platformOnly && user.role !== 'PLATFORM_ADMIN') {
    return <Navigate to="/" replace />;
  }
  if (!platformOnly && user.role === 'PLATFORM_ADMIN') {
    return <Navigate to="/platform" replace />;
  }

  if (adminOnly && user.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
}
